import { render } from "./SidebarShare.vue?vue&type=template&id=1b3e42f6"
import script from "./SidebarShare.vue?vue&type=script&lang=js"
export * from "./SidebarShare.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__